import React from 'react'
import Icon from '@ant-design/icons'

const DownSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 8 6" fill="currentColor">
    <path
      d="M3.48099 4.92617L0.172037 1.14392C-0.218469 0.69891 0.0989034 2.53695e-07 0.691562 2.53695e-07H7.30947C7.4421 -0.000113467 7.57196 0.0380073 7.68349 0.109798C7.79502 0.181588 7.88349 0.284005 7.93831 0.404783C7.99313 0.525561 8.01198 0.659582 7.99259 0.790794C7.9732 0.922006 7.9164 1.04485 7.82899 1.14461L4.52004 4.92548C4.45528 4.99959 4.37542 5.05898 4.28581 5.09968C4.19621 5.14037 4.09893 5.16143 4.00051 5.16143C3.9021 5.16143 3.80482 5.14037 3.71522 5.09968C3.62561 5.05898 3.54575 4.99959 3.48099 4.92548V4.92617Z"
      />
  </svg>
)

const DownIcon = props => <Icon component={DownSvg} {...props} />

export default DownIcon